import { IStyle, mergeStyles } from '@fluentui/react/lib/Styling';
import { getItemContentStyles } from '../CalendarSurfaceItemComponentRenderer';
import {
    CalendarSurfaceItemStyleProps,
    CalendarSurfaceItemStyles,
} from './CalendarSurfaceItem.types';
import surfaceFocusStyles from '../../utils/surfaceFocusStyles';

export const getStyles = (props: CalendarSurfaceItemStyleProps): CalendarSurfaceItemStyles => {
    const { freeBusyType, colorScheme, responseType, isCancelled, useBoldTheme } = props;

    return {
        root: computeRootStyles(props),
        content: getItemContentStyles(
            freeBusyType,
            responseType,
            colorScheme,
            isCancelled,
            useBoldTheme
        ),
    };
};

export const getAllDayStyles = (
    props: CalendarSurfaceItemStyleProps
): CalendarSurfaceItemStyles => {
    const {
        freeBusyType,
        colorScheme,
        responseType,
        hideBorder,
        isCancelled,
        useBoldTheme,
    } = props;

    return {
        root: computeRootStyles(props),
        content: [
            mergeStyles(
                getItemContentStyles(
                    freeBusyType,
                    responseType,
                    colorScheme,
                    isCancelled,
                    useBoldTheme
                )
            ),
            hideBorder &&
                responseType != 'NoResponseReceived' && {
                    selectors: {
                        '&::after': {
                            borderColor: 'transparent',
                        },
                    },
                },
        ],
    };
};

function computeRootStyles(props: CalendarSurfaceItemStyleProps): IStyle {
    const { className, theme, useBoldTheme } = props;

    return [
        mergeStyles(
            className,
            theme ? surfaceFocusStyles('absolute', theme, useBoldTheme) : undefined,
            {
                width: '100%',
                selectors: {
                    '.addFocusOutline &:focus': {
                        outline: 'transparent !important', // Override .addFocusOutline !important
                        padding: useBoldTheme ? '2px 2px 2px 6px' : '',
                        selectors: {
                            ['&:focus:after']: {
                                zIndex: 3, //override default z-index of 1 so that the outline shows above the free busy bar
                            },
                        },
                    },
                },
            }
        ),
    ];
}
